import { Role } from 'utils/api/User'

import { useCurrentUser } from './useCurrentUser'

export const useIsAdmin = () => useCurrentUser()?.roles?.includes(Role.ROLE_ADMIN)
